<template>
  <div class="work_detail">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
          <img v-if="URL_MAQIN==2" src="../assets/img/kjc返回.png" alt />
          <img v-if="URL_MAQIN==1" src="../assets/img/返回.png" alt />
          返回上一页
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
          <el-breadcrumb-item>练习</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- <button class="report" @click="goReport" v-if="wrong_list.length-1==current_index&&wrong_list[current_index].userAnswer">查看报告</button> -->
      </div>
      <div class="content_box clearfix">
        <div class="content_box_l">
          <div class="content_box_l_title">练习</div>
          <!-- 答题卡 -->
          <div class="topic_card">
            <div class="card_alt clearfix">
              <div class="card_alt_item clearfix">
                <span class="lv"></span>正确
              </div>
              <div class="card_alt_item">
                <span class="red"></span>错误
              </div>
              <div class="card_alt_item">
                <span></span>未答
              </div>
            </div>
            <div class="topic_card_box">
              <div class="topic_card_item" v-for="(item,index) in questionTypes" :key="index">
                <div class="card_item_title">{{item.type_name}}</div>
                <div class="card_box clearfix">
                  <div
                    class="number_list"
                    v-for="(item1,index) in item.questions"
                    :key="index"
                    @click="card_cl(item1.i)"
                    :class="err_or_true_list[item1.i-1]==true? 'lv':(err_or_true_list[item1.i-1]==false?'red':'') "
                  >{{item1.i}}</div>
                </div>
              </div>
            </div>

            <div class="new_make huang" @click="again_click">重做</div>
          </div>
        </div>
        <div class="content_box_r">
          <div class="work_box">
            <!-- 题 -->
            <div
              class="work_box_content"
              v-for="(item,index) in wrong_list"
              :key="index"
              v-show="current_index ==index"
            >
              <!-- 单选题 -->
              <div class="topic_box" v-if="item.type ==1">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <div class="work_name" v-html="item.parentStem"></div>
                  <div class="work_name" v-html="item.stem"></div>

                  <div class="answer">
                    <div
                      class="answer_list clearfix"
                      v-for="(item1,i) in item.metas"
                      :key="i"
                      @click="checkAnswer(i,item,index)"
                    >
                      <span
                        :class="answer_state_list[index][i]"
                      >{{answer_state_list[index][i]?(answer_state_list[index][i]=="answer-right"? '✓': answer_state_list[index][i]=="answer-error"?'X':item1.key ):item1.key}}</span>
                      <!-- <div class="work_key" v-html="item1.meta"></div> -->
                      <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                    </div>
                  </div>
                </div>
                <!-- 答过就显示 -->
                <div class="yida" v-show="item.userAnswer||error_list[index]">
                  <div style="background: #E6FAF5;">正确答案<span style="color:#1FD6A8;">{{ item.trueAnswer }}</span></div>
                  <div style="background: #FFDEDE;">你的答案<span style="color: #E62600;">{{item.userAnswer || "无"}}</span></div>
                  <div style="background: rgba(93, 148, 255, 0.28);">考点正确率<span style="color:#5D94FF;">{{item.right_rate?item.right_rate+'%':'0%'}}</span></div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-show="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <!-- <div class="trueanswer">
                      <span>答案：</span>
                      {{item.trueAnswer}}
                    </div> -->
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}

                      <span class="starBox" style="margin-left:16px"><img style="width:18px;margin-right:8px" src="../assets/img/star.png" alt="" v-for="item in item.star_level"></span>
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>

                  <!-- 视频解析 -->
                  <div class="videoBox">

                    <div class="vBox" v-if="item.video_info">
                      <div class="vTitle">题目解析</div>
                      <img :src="item.video_info.logo" alt="">
                      <span>{{item.video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(1)"></div>
                    </div>

                    <div class="vBox" v-if="item.knowledge_video_info">
                      <div class="vTitle">知识点学习</div>
                      <img :src="item.knowledge_video_info.logo" alt="">
                      <span>{{item.knowledge_video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(2)"></div>
                    </div>

                  </div>

                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">

                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <!-- <div class="btn" v-if="item.video_id" @click="goVideo(1)" style="float:left;width:120px;margin-right:24px">
                        <img style="width:18px;margin-right:6px" src="../assets/img/player.png" alt="">
                        视频解析
                    </div> -->
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>

                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="goVideo(2)" v-if="$route.query.isBr==1&&wrong_list[current_index].knowledge_video_id">
                        <img src="../assets/img/huigu.png" alt="" style="margin-right:6px">
                      回顾考点
                    </div>
                    <div class="show_resolve" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                    <div class="show_resolve" @click="calc_click">
                      计算器
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多选 -->
              <div class="topic_box" v-if="item.type ==2">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <div class="work_name" v-html="item.parentStem"></div>
                  <div class="work_name" v-html="item.stem"></div>

                  <div class="answer">
                    <div
                      class="answer_list clearfix"
                      v-for="(item1,i) in item.metas"
                      :key="i"
                      @click="checkAnswer(i,item,index)"
                    >
                      <span
                        class="more"
                        :class="[active_list[index][i], answer_state_list[index][i]]"
                      >{{answer_state_list[index][i]?(answer_state_list[index][i]=="answer-right"? '✓': answer_state_list[index][i]=="answer-error"?'X':item1.key ):item1.key}}</span>
                      <!-- <div class="work_key" v-html="item1.meta"></div> -->
                      <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                    </div>
                  </div>
                </div>
                <!-- 确定按钮 -->
                <div class="certain">
                  <div class="certain_btn huang" v-if="more_list[index]" @click="fix_click(item)">确定</div>
                  <div class="certain_btn" v-else>确定</div>
                </div>
                <!-- 答过就显示 -->
                <div class="yida" v-show="item.userAnswer||error_list[index]">
                  <div style="background: #E6FAF5;">正确答案<span style="color:#1FD6A8;">{{ item.trueAnswer }}</span></div>
                  <div style="background: #FFDEDE;">你的答案<span style="color: #E62600;">{{item.userAnswer || "无"}}</span></div>
                  <div style="background: rgba(93, 148, 255, 0.28);">考点正确率<span style="color:#5D94FF;">{{item.right_rate?item.right_rate+'%':'0%'}}</span></div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-show="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <!-- <div class="trueanswer">
                      <span>答案：</span>
                      {{item.trueAnswer}}
                    </div> -->
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>

                  <!-- 视频解析 -->
                  <div class="videoBox">

                    <div class="vBox" v-if="item.video_info">
                      <div class="vTitle">题目解析</div>
                      <img :src="item.video_info.logo" alt="">
                      <span>{{item.video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(1)"></div>
                    </div>

                    <div class="vBox" v-if="item.knowledge_video_info">
                      <div class="vTitle">知识点学习</div>
                      <img :src="item.knowledge_video_info.logo" alt="">
                      <span>{{item.knowledge_video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(2)"></div>
                    </div>

                  </div>

                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">
                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <!-- <div class="btn" v-if="item.video_id" @click="goVideo(1)" style="float:left;width:120px;margin-right:24px">
                        <img style="width:18px;margin-right:6px" src="../assets/img/player.png" alt="">
                        视频解析
                    </div> -->
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>
                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                    <div class="show_resolve" @click="calc_click">
                      计算器
                    </div>
                  </div>
                </div>
              </div>
              <!-- 判断 -->
              <div class="topic_box" v-if="item.type ==3">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <div class="work_name" v-html="item.parentStem"></div>
                  <div class="work_name" v-html="item.stem"></div>

                  <div class="answer">
                    <div
                      class="answer_list clearfix"
                      v-for="(item1,i) in item.metas"
                      :key="i"
                      @click="checkAnswer(i,item,index)"
                    >
                      <span
                        :class="answer_state_list[index][i]"
                      >{{answer_state_list[index][i]?(answer_state_list[index][i]=="answer-right"? '✓': answer_state_list[index][i]=="answer-error"?'X':item1.key ):item1.key}}</span>
                      <!-- <div class="work_key" v-html="item1.meta"></div> -->
                      <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                    </div>
                  </div>
                </div>
                <!-- 答过就显示 -->
                <div class="yida" v-show="item.userAnswer||error_list[index]">
                  <div style="background: #E6FAF5;">正确答案<span style="color:#1FD6A8;">{{ item.trueAnswer }}</span></div>
                  <div style="background: #FFDEDE;">你的答案<span style="color: #E62600;">{{item.userAnswer || "无"}}</span></div>
                  <div style="background: rgba(93, 148, 255, 0.28);">考点正确率<span style="color:#5D94FF;">{{item.right_rate?item.right_rate+'%':'0%'}}</span></div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-show="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <!-- <div class="trueanswer">
                      <span>答案：</span>
                      {{item.trueAnswer}}
                    </div> -->
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>

                  <!-- 视频解析 -->
                  <div class="videoBox">

                    <div class="vBox" v-if="item.video_info">
                      <div class="vTitle">题目解析</div>
                      <img :src="item.video_info.logo" alt="">
                      <span>{{item.video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(1)"></div>
                    </div>

                    <div class="vBox" v-if="item.knowledge_video_info">
                      <div class="vTitle">知识点学习</div>
                      <img :src="item.knowledge_video_info.logo" alt="">
                      <span>{{item.knowledge_video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(2)"></div>
                    </div>

                  </div>


                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">
                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <!-- <div class="btn" v-if="item.video_id" @click="goVideo(1)" style="float:left;width:120px;margin-right:24px">
                        <img style="width:18px;margin-right:6px" src="../assets/img/player.png" alt="">
                        视频解析
                    </div> -->
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>
                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                    <div class="show_resolve" @click="calc_click">
                      计算器
                    </div>
                  </div>
                </div>
              </div>
              <!-- 不定项 -->
              <div class="topic_box" v-if="item.type ==4">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <div class="work_name" v-html="item.parentStem"></div>
                  <div class="work_name" v-html="item.stem"></div>

                  <div class="answer">
                    <div
                      class="answer_list clearfix"
                      v-for="(item1,i) in item.metas"
                      :key="i"
                      @click="checkAnswer(i,item,index)"
                    >
                      <span
                        class="more"
                        :class="[active_list[index][i], answer_state_list[index][i]]"
                      >{{answer_state_list[index][i]?(answer_state_list[index][i]=="answer-right"? '✓': answer_state_list[index][i]=="answer-error"?'X':item1.key ):item1.key}}</span>
                      <!-- <div class="work_key" v-html="item1.meta"></div> -->
                      <pre class="work_key" style="white-space: pre-wrap;padding-left: 60px;" v-html=" item1.meta"></pre>
                    </div>
                  </div>
                </div>
                <!-- 确定按钮 -->
                <div class="certain">
                  <div class="certain_btn huang" v-if="more_list[index]" @click="fix_click(item)">确定</div>
                  <div class="certain_btn" v-else>确定</div>
                </div>
                <!-- 答过就显示 -->
                <div class="yida" v-show="item.userAnswer||error_list[index]">
                  <div style="background: #E6FAF5;">正确答案<span style="color:#1FD6A8;">{{ item.trueAnswer }}</span></div>
                  <div style="background: #FFDEDE;">你的答案<span style="color: #E62600;">{{item.userAnswer || "无"}}</span></div>
                  <div style="background: rgba(93, 148, 255, 0.28);">考点正确率<span style="color:#5D94FF;">{{item.right_rate?item.right_rate+'%':'0%'}}</span></div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-show="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <!-- <div class="trueanswer">
                      <span>答案：</span>
                      {{item.trueAnswer}}
                    </div> -->
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>

                  <!-- 视频解析 -->
                  <div class="videoBox">

                    <div class="vBox" v-if="item.video_info">
                      <div class="vTitle">题目解析</div>
                      <img :src="item.video_info.logo" alt="">
                      <span>{{item.video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(1)"></div>
                    </div>

                    <div class="vBox" v-if="item.knowledge_video_info">
                      <div class="vTitle">知识点学习</div>
                      <img :src="item.knowledge_video_info.logo" alt="">
                      <span>{{item.knowledge_video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(2)"></div>
                    </div>

                  </div>


                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">
                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <!-- <div class="btn" v-if="item.video_id" @click="goVideo(1)" style="float:left;width:120px;margin-right:24px">
                        <img style="width:18px;margin-right:6px" src="../assets/img/player.png" alt="">
                        视频解析
                    </div> -->
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>
                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                    <div class="show_resolve" @click="calc_click">
                      计算器
                    </div>
                  </div>
                </div>
              </div>
              <!-- 简答 -->
              <div class="topic_box" v-if="item.type >4">
                <div class="topic_top clearfix">
                  <div class="number">
                    <span>{{index+1}}</span>
                    /{{wrong_list.length}}
                  </div>
                  <div class="type">{{item.type_name}}</div>
                </div>
                <div class="topic_bottom">
                  <div class="work_name" v-html="item.parentStem"></div>
                  <div class="work_name" v-html="item.stem"></div>

                  <div class="answer">
                    <el-input
                      type="textarea"
                      :rows="4"
                      :placeholder="answer_state_list[index][0]"
                      resize="none"
                      v-model="value1"
                      @input="input_value"
                      :readonly="answer_state_list[index][1]"
                    ></el-input>
                  </div>
                </div>
                <div class="certain">
                  <div
                    class="certain_btn huang"
                    v-if="more_list[index]"
                    @click="input_blur(index,item)"
                  >确定</div>
                  <div class="certain_btn" v-else>确定</div>
                </div>
                <!-- 解析 -->
                <div class="resolve_box" v-show="error_list[index]">
                  <div class="min_title clearfix">
                    <span></span> 题目解析
                  </div>
                  <div class="resolve">
                    <div class="trueanswer">
                      <span>答案：</span>
                      <span v-html="item.trueAnswer"></span>
                    </div>
                    <div class="trueanswer">
                      <span>考点：</span>
                      {{item.knowledge_name}}
                    </div>
                    <div class="trueanswer">
                      <span>解析：</span>
                      <div class="analysis_c_box" v-html="item.analysis"></div>
                    </div>
                  </div>
                  <div class="min_title clearfix" v-if="URL_MAQIN==2">
                    <span></span> 提问
                  </div>

                  <!-- 视频解析 -->
                  <div class="videoBox">

                    <div class="vBox" v-if="item.video_info">
                      <div class="vTitle">题目解析</div>
                      <img :src="item.video_info.logo" alt="">
                      <span>{{item.video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(1)"></div>
                    </div>

                    <div class="vBox" v-if="item.knowledge_video_info">
                      <div class="vTitle">知识点学习</div>
                      <img :src="item.knowledge_video_info.logo" alt="">
                      <span>{{item.knowledge_video_info.duration_format}}</span>
                      <div class="zhezhao" @click="goVideo(2)"></div>
                    </div>

                  </div>


                  <div class="alt" v-if="URL_MAQIN==2">针对该题目您有什么疑问，可下下方输入，并点击提交，老师将会及时为您解答。</div>
                  <div class="textarea_box clearfix">
                    <el-input
                      v-if="URL_MAQIN==2"
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      resize="none"
                      v-model="value"
                      @input="input_c"
                    ></el-input>
                    <!-- <div class="btn" v-if="item.video_id" @click="goVideo(1)" style="float:left;width:120px;margin-right:24px">
                        <img style="width:18px;margin-right:6px" src="../assets/img/player.png" alt="">
                        视频解析
                    </div> -->
                    <div class="btn" v-if="URL_MAQIN==1" @click="btn_click" style="float:left">发起提问</div>
                  </div>
                </div>
                <div class="operate_box clearfix">
                  <div class="operate_box_l clearfix">
                    <div class="up" @click="up_click">上一题</div>
                    <div class="next" @click="next_click">下一题</div>
                  </div>
                  <div class="operate_box_r clearfix">
                    <div class="faver" @click="collection_click">
                      <img
                        v-if="wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1"
                        src="../assets/img/favorite.png"
                        alt
                      />
                      <img v-else src="../assets/img/favorite1.png" alt />
                      {{wrong_list[current_index]&&wrong_list[current_index].is_favorite ==1? '取消收藏':'收藏'}}
                    </div>
                    <div class="show_resolve" @click="analysis_click">
                      <img src="../assets/img/Shape.png" alt />
                      {{error_list[current_index]? '隐藏':'显示'}}解析
                    </div>
                    <div class="show_resolve" @click="calc_click">
                      计算器
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- 巩固视频 -->
    <el-dialog
    :visible.sync="isShowModal"
    width="60%"
    :before-close="handleClose"
    class="ggVideoBox">
    <div>
        <div id="J_prismPlayer" class="prism-player"></div>
    </div>
    </el-dialog>

  </div>
</template>
<script>
import "@/assets/js/aliplayercomponents-1.0.5.min.js";
import {
  Wrong,
  SaveResult,
  SaveComment,
  DeleteWrong,
  SaveFavorite,
  Favorite,
  Exercise,
  Crumbs,
  knowledgeVideo,
  VideoError
} from "@/api/index";
import appConfig from '@/api/appConfig';
import calc from '@/components/calc'
export default {
  data() {
    return {
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      textarea_ans: "", //用户输入答案
      textarea: "", //提问输入
      value: "",
      value1: "",
      chapter_id: "", //知识点id
      btn_show: true, //提问按钮变化
      analysis_show: false, //解析的显示隐藏
      analysis_value: "查看",
      length: "",
      Jump_index: 0, //跳转的index
      wrong_list: [{ is_favorite: 0 }], //题目列表
      answer_state_list: [], //二维数组
      current_index: 0, //当前题目下标
      answer_state_lock: [], //记录题目是否已答
      error_list: [], //记录解每道题解析是否显示
      more_list: [], //记录多选题确定按钮的显示隐藏
      moreArr: [], //
      active_list: [], //多选题选中时数组,
      questionTypes: [], //答题卡,
      sum: 0,
      err_or_true_list: [], //判断答题卡是否对错
      rule_tag: "",
      levelList: {},
      isShowModal:false,

      video_detail:'',
      player: null,
      timer:'',



    };
  },
  mounted() {
    this.$utils.banCopy()
    // this.chapter_id = this.$route.query.chapter_id;
    // // console.log(this.$route.query.subject_id);\
    // this.rule_tag = this.$route.query.rule_tag;
    // // this.crumbs( this.$route.query.course_id,this.$route.query.chapter_id)
    // if (this.$route.query.cid) {
    //   let obj1 = {};
    //   obj1.chapter_id = this.$route.query.chapter_id;
    //   obj1.course_id = this.$route.query.course_id;
    //   obj1.rule_tag = this.$route.query.rule_tag;
    //   obj1.course_chapter_id = this.$route.query.course_chapter_id;
    //   // obj1.cid = this.$route.query.cid;
    //   this.request1(obj1);
    // } else {
    //   let obj = {};
    //   obj.chapter_id = this.$route.query.chapter_id;
    //   obj.course_id = this.$route.query.course_id;
    //   obj.rule_tag = this.$route.query.rule_tag;
    //   obj.course_chapter_id = this.$route.query.course_chapter_id;
    //   this.request(obj);
    // }
  },
  beforeRouteEnter(to, from, next) {
    console.log(to,from)
    // ||from.path=='/playbackZsd'&&!to.query.isBr
    if(from.path=='/knowledgeStudy'||from.path=='/'||from.path=='/brzsd'||from.query.isLoad==1){
      from.meta.keepAlive = true;
      next(vm=>{
        console.log(vm)
        vm.reload();
      })
    }else{
      next(vm=>{
        vm.sessionM()
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, from)
    if (to.path == "/playbackZsd"||to.path == "/knowledgeStudy") {
      if(!from.meta.keepAlive){
        from.meta.keepAlive = true;
      }
    }else{
      // from.meta.keepAlive = false;
      // this.$destroy()
    }
    next();
  },
  activated(){
    // console.log('设置index',sessionStorage.getItem('currQuestionIndex'))
    // console.log(222222222222,this.answer_state_lock,this.wrong_list,this.answer_state_list)
  },
  destroyed() {
    console.log("关闭");
    //如果定时器在运行则关闭
    let _this = this;
    clearInterval(_this.timer);
  },
  methods: {
    sessionM(){
      // 恢复题目状态
      if(sessionStorage.getItem('currQuestionIndex')){
        this.current_index = sessionStorage.getItem('currQuestionIndex')
        this.Jump_index = sessionStorage.getItem('currQuestionIndex')
        sessionStorage.removeItem('currQuestionIndex')
      }else{
        this.current_index=0
        this.Jump_index=0
      }
      if(sessionStorage.getItem('answer_state_lock')){
        this.answer_state_lock = JSON.parse(sessionStorage.getItem('answer_state_lock'))
        sessionStorage.removeItem('answer_state_lock')
      }
      if(sessionStorage.getItem('wrong_list')){
        this.wrong_list = JSON.parse(sessionStorage.getItem('wrong_list'))
        sessionStorage.removeItem('wrong_list')
      }
      console.log('题目勾选',sessionStorage.getItem('answer_state_list'))
      if(sessionStorage.getItem('answer_state_list')){
        this.answer_state_list = JSON.parse(sessionStorage.getItem('answer_state_list'))
        sessionStorage.removeItem('answer_state_list')
      }
      if(sessionStorage.getItem('active_list')){
        this.active_list = JSON.parse(sessionStorage.getItem('active_list'))
        sessionStorage.removeItem('active_list')
      }
      if(sessionStorage.getItem('active_list')){
        this.active_list = JSON.parse(sessionStorage.getItem('active_list'))
        sessionStorage.removeItem('active_list')
      }
    },
    handleClose(){
      if(this.player) this.player.pause();
      this.isShowModal=false
    },
    videoDtailM(id) {
      let that = this
      return new Promise(function(resolve,reject){
        knowledgeVideo(id).then(res=>{
            console.log(res);
            that.video_detail = res.data;
            if(!that.video_detail.video_id) return
            if (that.player==null) {
              // that.memory(id);
              that.isShowModal=true
              that.$nextTick(()=>{
                that.playback( that.video_detail.sign.video_video_id, that.video_detail.sign.playAuth, that.video_detail.video_thumb, that.video_detail.is_encrypt, that.video_detail.sign.MtsHlsUriToken);
                console.log(1);
              })
              
            }else{
              that.isShowModal=true
              that.$nextTick(()=>{
                that.player.replayByVidAndPlayAuth(that.video_detail.sign.video_video_id, that.video_detail.sign.playAuth, that.video_detail.video_thumb, that.video_detail.is_encrypt, that.video_detail.sign.MtsHlsUriToken);
                console.log(2);
              })
            }
            resolve()
          })
        
      })
    },
    playback(video_id, playAuth,video_thumb,is_encrypt,MtsHlsUriToken) {
      let  _this = this;

      if (this.player == null) {
        this.player = new Aliplayer(
          {
            id: "J_prismPlayer", // 容器id
            autoplay: true, // 是否自动播放
            width: "100%", // 播放器宽度
            height: "600px", // 播放器高度
            showBuffer: false,
            playsinline: true,
            preload: true,
            useH5Prism: true,
            useFlashPrism: false,
            x5_video_position: "center", // 指定视频播放位置,top,center
            x5_type: "auto", // 声明启用同层h5播放器
            x5_fullscreen: true, // 声明视频播放时是否进入到 TBS 的全屏模式，支持的值：true
            x5_orientation: "portraint", //声明 TBS 播放器支持的方向，可选值：landscape:横屏）portraint:竖屏:跟随手机自动旋转
            // source:
            // "http://cloud.video.taobao.com/play/u/2554695624/p/1/e/6/t/1/fv/102/28552077.mp4", //视频地址
            vid: video_id,
            playauth: playAuth,
            cover: video_thumb, //播放器封面图
            // encryptType: is_encrypt,
            playConfig:{MtsHlsUriToken: MtsHlsUriToken},
            components: [
              {
                name: "RateComponent",
                type: AliPlayerComponent.RateComponent
              },
              {
                name: "MemoryPlayComponent",
                type: AliPlayerComponent.MemoryPlayComponent,
                /* Set the first parameter to true to enable auto play. The default is false. */
                args: [false, _this.getTime, _this.saveTime]
              }
            ]
          },
          function(player) {}
        );
      }
      var player = this.player;
      player.on("play", function(e) {
        console.log("开始");
        clearInterval(_this.timer);
        // _this.getLastTime();
      });
      player.on("timeupdate", function(e) {
        _this.time_c = player.getCurrentTime();
        // localStorage.setItem(
        //   _this.video_detail.sign.video_video_id,
        //   player.getCurrentTime()
        // );
        // console.log(player.getCurrentTime());
      });
      player.on("pause", function(e) {
        console.log("暂停");
        clearInterval(_this.timer);
      });

      player.on("ended", function(e) {
        console.log("结束");
        clearInterval(_this.timer);
        let progressobj = {};
        progressobj.chapter_id = _this.chapter_id;
        progressobj.progress = 10;
        progressobj.previous = _this.time_c;
        Progress(progressobj).then(res => {
          console.log(res);
        });
      });

        player.on("error", function (e) {
            if (e && "paramData" in e && "error_code" in e.paramData && "error_msg" in e.paramData && "mediaId" in e.paramData) {
                var obj = {
                    error_code: e.paramData.error_code,
                    error_msg: e.paramData.error_msg,
                    video_id: e.paramData.mediaId
                };
                console.log("obj",obj);
                VideoError(obj).then((res) => {
                });
            }
        });

    },
    goVideo(type){
      sessionStorage.setItem('currQuestionIndex',this.current_index)
      // 1视频讲解2回顾考点
      if(type==1){
        sessionStorage.setItem("id", this.wrong_list[this.current_index].id);
        sessionStorage.setItem("answer_state_list", JSON.stringify(this.answer_state_list));
        this.$router.push({ path: "playbackZsd",query: {
            course_id:this.wrong_list[this.current_index].id,
            chapter_id:this.$route.query.chapter_id,
            subject_id: this.$route.query.subject_id,
            type:type,
            isBack:1
          }
        });
      }else{
        if(this.$route.query.isBr==1){
          this.isShowModal=true
          this.player.play();
        }else{
          sessionStorage.setItem("id", this.wrong_list[this.current_index].id);
          sessionStorage.setItem("answer_state_list", JSON.stringify(this.answer_state_list));
          this.$router.push({ path: "playbackZsd",query: {
              course_id:this.wrong_list[this.current_index].id,
              chapter_id:this.$route.query.chapter_id,
              subject_id: this.$route.query.subject_id,
              knowledge_id:this.wrong_list[this.current_index].knowledge_id,
              type:type
            }
          });
        }
      }
    },
    request(obj) {
      Exercise(obj).then(res => {
        if(res.questionList.length==0){
          this.$alert('暂无相关内容', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              
            }
          });
        }
        this.wrong_list = res.questionList;
        this.length = res.count;
        this.questionTypes = res.questionTypes;
        console.log(this.wrong_list);
        console.log('请求完成')
        // 初始化二维数组用于存放每个题目每个选项的状态
        for (let i = 0; i < this.wrong_list.length; i++) {
          this.answer_state_list[i] = [];
          this.active_list[i] = [];
          this.answer_state_lock[i] = false;
          this.error_list[i] = false;
          this.more_list[i] = false;
          this.err_or_true_list[i] = "h";
        }
        // copy down
        for (let i = 0; i < this.wrong_list.length; i++) {
          if (this.wrong_list[i].userAnswer) {
            this.answer_state_lock[i] = true;
            if (this.wrong_list[i].type == 1 || this.wrong_list[i].type == 3) {
              if (
                this.wrong_list[i].userAnswer == this.wrong_list[i].trueAnswer
              ) {
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  if (
                    this.wrong_list[i].userAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-right"
                    );
                    this.$set(this.err_or_true_list, i, true);
                  }
                }
              } else {
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  if (
                    this.wrong_list[i].trueAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-none"
                    );
                    this.$set(this.err_or_true_list, i, false);
                  }
                  if (
                    this.wrong_list[i].userAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-error"
                    );
                  }
                }
              }
            } else if (
              this.wrong_list[i].type == 2 ||
              this.wrong_list[i].type == 4
            ) {
              if (
                this.wrong_list[i].userAnswer == this.wrong_list[i].trueAnswer
              ) {
                // console.log(77777);
                let arr = this.wrong_list[i].trueAnswer.split("");
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  for (let k = 0; k < arr.length; k++) {
                    if (this.wrong_list[i].metas[j].key == arr[k]) {
                      this.changeArrValue(
                        this.answer_state_list,
                        i,
                        j,
                        "answer-right"
                      );
                      this.$set(this.err_or_true_list, i, true);
                    }
                  }
                }
              } else {
                let arr = this.wrong_list[i].userAnswer.split("");
                let arr1 = this.wrong_list[i].trueAnswer.split("");
                console.log(this.moreArr);

                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  for (let k = 0; k < arr1.length; k++) {
                    if (this.wrong_list[i].metas[j].key == arr1[k]) {
                      this.changeArrValue(
                        this.answer_state_list,
                        i,
                        j,
                        "answer-none"
                      );
                    }
                  }
                  for (let k = 0; k < arr.length; k++) {
                    for (let m = 0; m < arr1.length; m++) {
                      this.$set(this.err_or_true_list, i, false);
                      if (arr[k] == arr1[m]) {
                        let tag = 0;
                        if (arr[k] == "A") {
                          tag = 0;
                        } else if (arr[k] == "B") {
                          tag = 1;
                        } else if (arr[k] == "C") {
                          tag = 2;
                        } else if (arr[k] == "D") {
                          tag = 3;
                        }
                        this.changeArrValue(
                          this.answer_state_list,
                          i,
                          tag,
                          "answer-right"
                        );
                      } else if (
                        this.wrong_list[i].metas[j].key == arr[k] &&
                        arr[k] != arr1[m]
                      ) {
                        console.log(arr[k]);
                        this.changeArrValue(
                          this.answer_state_list,
                          i,
                          j,
                          "answer-error"
                        );
                      }
                    }
                  }
                }
              }
            } else {
              this.changeArrValue(
                this.answer_state_list,
                i,
                0,
                this.wrong_list[i].userAnswer
              );
              this.changeArrValue(this.answer_state_list, i, 1, true);
              this.$set(this.err_or_true_list, i, true);
            }
          }
        }

        // 显示解析v3
        if(this.dtType==1&&this.wrong_list[this.current_index].userAnswer){
          this.$set(
            this.error_list,
            this.current_index,
            true
          );
        }
        

        //恢复状态
        console.log('状态恢复1')
        this.sessionM()
      });
    },
    request1(obj) {
      Exercise(obj).then(res => {
        if(res.questionList.length==0){
          this.$alert('暂无相关内容', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              
            }
          });
        }
        this.wrong_list = res.questionList;
        this.length = res.count;
        this.questionTypes = res.questionTypes;
        this.Jump_index = res.last_index;
        this.current_index = res.last_index;
        // 初始化二维数组用于存放每个题目每个选项的状态
        for (let i = 0; i < this.wrong_list.length; i++) {
          this.answer_state_list[i] = [];
          this.active_list[i] = [];
          this.answer_state_lock[i] = false;
          this.error_list[i] = false;
          this.more_list[i] = false;
          this.err_or_true_list[i] = "h";
        }
        for (let i = 0; i < this.wrong_list.length; i++) {
          if (this.wrong_list[i].userAnswer) {
            this.answer_state_lock[i] = true;
            if (this.wrong_list[i].type == 1 || this.wrong_list[i].type == 3) {
              if (
                this.wrong_list[i].userAnswer == this.wrong_list[i].trueAnswer
              ) {
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  if (
                    this.wrong_list[i].userAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-right"
                    );
                    this.$set(this.err_or_true_list, i, true);
                  }
                }
              } else {
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  if (
                    this.wrong_list[i].trueAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-none"
                    );
                    this.$set(this.err_or_true_list, i, false);
                  }
                  if (
                    this.wrong_list[i].userAnswer ==
                    this.wrong_list[i].metas[j].key
                  ) {
                    this.changeArrValue(
                      this.answer_state_list,
                      i,
                      j,
                      "answer-error"
                    );
                  }
                }
              }
            } else if (
              this.wrong_list[i].type == 2 ||
              this.wrong_list[i].type == 4
            ) {
              if (
                this.wrong_list[i].userAnswer == this.wrong_list[i].trueAnswer
              ) {
                // console.log(77777);
                let arr = this.wrong_list[i].trueAnswer.split("");
                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  for (let k = 0; k < arr.length; k++) {
                    if (this.wrong_list[i].metas[j].key == arr[k]) {
                      this.changeArrValue(
                        this.answer_state_list,
                        i,
                        j,
                        "answer-right"
                      );
                      this.$set(this.err_or_true_list, i, true);
                    }
                  }
                }
              } else {
                let arr = this.wrong_list[i].userAnswer.split("");
                let arr1 = this.wrong_list[i].trueAnswer.split("");
                console.log(this.moreArr);

                for (let j = 0; j < this.wrong_list[i].metas.length; j++) {
                  for (let k = 0; k < arr1.length; k++) {
                    if (this.wrong_list[i].metas[j].key == arr1[k]) {
                      this.changeArrValue(
                        this.answer_state_list,
                        i,
                        j,
                        "answer-none"
                      );
                    }
                  }
                  for (let k = 0; k < arr.length; k++) {
                    for (let m = 0; m < arr1.length; m++) {
                      this.$set(this.err_or_true_list, i, false);
                      if (arr[k] == arr1[m]) {
                        let tag = 0;
                        if (arr[k] == "A") {
                          tag = 0;
                        } else if (arr[k] == "B") {
                          tag = 1;
                        } else if (arr[k] == "C") {
                          tag = 2;
                        } else if (arr[k] == "D") {
                          tag = 3;
                        }
                        this.changeArrValue(
                          this.answer_state_list,
                          i,
                          tag,
                          "answer-right"
                        );
                      } else if (
                        this.wrong_list[i].metas[j].key == arr[k] &&
                        arr[k] != arr1[m]
                      ) {
                        console.log(arr[k]);
                        this.changeArrValue(
                          this.answer_state_list,
                          i,
                          j,
                          "answer-error"
                        );
                      }
                    }
                  }
                }
              }
            } else {
              this.changeArrValue(
                this.answer_state_list,
                i,
                0,
                this.wrong_list[i].userAnswer
              );
              this.changeArrValue(this.answer_state_list, i, 1, true);
              this.$set(this.err_or_true_list, i, true);
            }
          }
        }

        //恢复状态
        console.log('状态恢复2')
        this.sessionM()
      });
    },
    favorite(id) {
      Favorite(id).then(res => {
        this.wrong_list = res.questionList;
        this.length = res.count;
        this.questionTypes = res.questionTypes;
        // 初始化二维数组用于存放每个题目每个选项的状态
        for (let i = 0; i < this.wrong_list.length; i++) {
          this.answer_state_list[i] = [];
          this.active_list[i] = [];
          this.answer_state_lock[i] = false;
          this.error_list[i] = false;
          this.more_list[i] = false;
          this.err_or_true_list[i] = "h";
        }
      });
    },
    crumbs(course_id, cid) {
      Crumbs(course_id, cid).then(res => {
        console.log(res);
        this.levelList = res;
      });
    },
    // 保存答案
    saveResult(obj) {
      SaveResult(obj).then(res => {
        // console.log(res);
      });
    },
    // 提问提交
    saveComment(obj) {
      SaveComment(obj).then(res => {
        this.value = "";
        this.btn_show = true;
        if (res.status == 200) {
          this.$message({
            message: res.data.data,
            type: "success"
          });
        } else {
          this.$message.error(res.data.data);
        }
      });
    },
    // 删除我的错题
    deleteWrong(id) {
      DeleteWrong(id).then(res => {
        console.log(res);
      });
    },
    //收藏题目
    saveFavorite(id) {
      SaveFavorite(id).then(res => {
        console.log(res);
        if (res.status == 200) {
          this.$message({
            message: res.data.data,
            type: "success"
          });
        } else {
          this.$message.error(res.data.data);
        }
      });
    },
    // 改变二维数组的值
    changeArrValue(arr, index, jndex, value) {
      let array = arr[index];
      array[jndex] = value;
      arr.splice(index, 1, array);
      // console.log(this.answer_state_list);
    },
    change_active_list(arr, index, jndex, value) {
      let array = arr[index];
      array[jndex] = value;
      arr.splice(index, 1, array);
      // console.log(666);
    },
    // 判断选择对错
    checkAnswer(index, items, father_index) {
      // console.log(this.current_index);
      // console.log(index);
      if (this.answer_state_lock[this.current_index]) {
        return;
      }
      // 单选
      if (items.type == 1 || items.type == 3) {
        let Mobj = {};
        Mobj.rule_tag = this.rule_tag;
        Mobj.chapter_id = this.chapter_id;
        Mobj.question_id = items.question_id;
        Mobj.userAnswer = items.metas[index].key;
        Mobj.trueAnswer = items.trueAnswer;
        // console.log(Mobj);
        this.saveResult(Mobj); //提交
        var trueIndex = 0;
        for (let i = 0; i < items.metas.length; i++) {
          if (items.trueAnswer == items.metas[i].key) {
            trueIndex = i;
          }
        }
        if (items.trueAnswer == items.metas[index].key) {
          this.changeArrValue(
            this.answer_state_list,
            this.current_index,
            index,
            "answer-right"
          );
          this.answer_state_lock[this.current_index] = true;
          // console.log(this.answer_state_lock);
          this.$set(this.err_or_true_list, this.current_index, true);

          if (this.current_index == this.answer_state_list.length - 1) {
          } else {
            setTimeout(() => {
              this.current_index += 1;
            }, 500);
          }

          // console.log(this.err_or_true_list);
          // 显示解析
          this.$set(
            this.error_list,
            this.current_index,
            true
          );
        } else {
          this.changeArrValue(
            this.answer_state_list,
            this.current_index,
            index,
            "answer-error"
          );

          this.changeArrValue(
            this.answer_state_list,
            this.current_index,
            trueIndex,
            "answer-right"
          );
          // 显示解析
          this.$set(
            this.error_list,
            this.current_index,
            !this.error_list[this.current_index]
          );
          this.answer_state_lock[this.current_index] = true;
          this.$set(this.err_or_true_list, this.current_index, false);
          console.log(this.err_or_true_list);
        }

        // 插入用户答案v3
        items.userAnswer = items.metas[index].key
      } else if (items.type == 2) {
        // 多选

        // 点击选中
        if (this.active_list[this.current_index][index] == "huang") {
          // this.moreArr = this.moreArr.splice(index, 1);
          for (var i = 0; i < this.moreArr.length; i++) {
            if (i == index) {
              // this.moreArr.splice(i, 1);
              // break;
              this.$set(this.moreArr, index, "");
              // for(let i=0;i<this.moreArr.length;i++){
              //   if(!this.moreArr[i]){
              //     this.moreArr.splice(i,1)
              //   }
              // }
              this.sum -= 1;
            }
          }
          this.moreArr = this.moreArr;
          console.log(this.moreArr);
          if (this.sum >= 2) {
            this.$set(this.more_list, this.current_index, true);
          } else {
            this.$set(this.more_list, this.current_index, false);
          }
          this.change_active_list(
            this.active_list,
            this.current_index,
            index,
            "h"
          );
        } else {
          // 判断确定按钮
          this.sum += 1;
          this.$set(this.moreArr, index, items.metas[index].key);
          // this.moreArr.push(items.metas[index].key);
          // this.moreArr = [...new Set(this.moreArr)];
          console.log(this.moreArr);

          if (this.sum >= 2) {
            this.$set(this.more_list, this.current_index, true);
          } else {
            this.$set(this.more_list, this.current_index, false);
          }
          // console.log(22222);
          this.change_active_list(
            this.active_list,
            this.current_index,
            index,
            "huang"
          );
        }

        // console.log(this.active_list);
        // console.log(this.active_list);
      } else if (items.type == 4) {
        // 不定项
        // 点击选中

        if (this.active_list[this.current_index][index] == "huang") {
          for (var i = 0; i < this.moreArr.length; i++) {
            if (i == index) {
              // this.moreArr.splice(i, 1);
              // break;
              this.$set(this.moreArr, index, 0);
              this.sum -= 1;
            }
          }
          this.moreArr = this.moreArr;
          console.log(this.moreArr);
          console.log(this.sum);
          if (this.sum == 0) {
            this.$set(this.more_list, this.current_index, false);
          } else {
            this.$set(this.more_list, this.current_index, true);
          }

          this.change_active_list(
            this.active_list,
            this.current_index,
            index,
            "h"
          );
        } else {
          // 判断确定按钮
          this.sum += 1;
          this.$set(this.moreArr, index, items.metas[index].key);
          // this.moreArr.push(items.metas[index].key);
          // this.moreArr = [...new Set(this.moreArr)];
          // console.log(index);
          console.log(this.moreArr);
          if (this.moreArr.length > 0) {
            this.$set(this.more_list, this.current_index, true);
          } else {
            this.$set(this.more_list, this.current_index, false);
          }
          // console.log(22222);
          this.change_active_list(
            this.active_list,
            this.current_index,
            index,
            "huang"
          );
        }
      }

      // if (items.type == 1||items.type == 3) {
      //   // 查看报告
      //   if(father_index==this.wrong_list.length-1){
      //     this.$nextTick(()=>{
      //       this.goReport()
      //     })
      //   }
      // }



    },
    // 点击确定
    fix_click(item) {
      let showUserAnswer = this.moreArr.toString().replace(new RegExp(",","gm"),"").replace(new RegExp("0","gm"),"");//.replaceAll(',','').replaceAll('0','')
      let newArr = item.trueAnswer.split("");
      // console.log(newArr);
      console.log(this.moreArr);
      let Fill_moreArr = this.moreArr.filter(d => d);

      let Mobj = {};
      Mobj.rule_tag = this.rule_tag;
      Mobj.chapter_id = this.chapter_id;
      Mobj.question_id = item.question_id;
      Mobj.userAnswer = this.moreArr.join("");
      Mobj.trueAnswer = item.trueAnswer;
      // console.log(Mobj);
      this.saveResult(Mobj); //提交
      this.answer_state_lock[this.current_index] = true;
      if (
        JSON.stringify(newArr.sort()) == JSON.stringify(Fill_moreArr.sort())
      ) {
        for (let i = 0; i < item.metas.length; i++) {
          for (let j = 0; j < this.moreArr.length; j++) {
            if (item.metas[i].key == this.moreArr[j]) {
              this.changeArrValue(
                this.answer_state_list,
                this.current_index,
                i,
                "answer-right"
              );
            }
          }
        }
        this.$set(this.more_list, this.current_index, false);
        this.answer_state_lock[this.current_index] = true;
        this.$set(this.err_or_true_list, this.current_index, true);
        if (this.current_index == this.answer_state_list.length - 1) {
        } else {
          setTimeout(() => {
            this.current_index += 1;
          }, 500);
        }
        this.moreArr = [];
      } else {
        console.log(2);
        for (let i = 0; i < item.metas.length; i++) {
          for (let j = 0; j < newArr.length; j++) {
            if (item.metas[i].key == newArr[j]) {
              console.log();
              this.changeArrValue(
                this.answer_state_list,
                this.current_index,
                i,
                "answer-right"
              );
            }
          }
        }
        let arr1 = this.moreArr.filter(item => newArr.indexOf(item) == -1);
        for (let i = 0; i < item.metas.length; i++) {
          for (let j = 0; j < arr1.length; j++) {
            if (item.metas[i].key == arr1[j]) {
              this.changeArrValue(
                this.answer_state_list,
                this.current_index,
                i,
                "answer-error"
              );
            }
          }
        }
        let arr2 = newArr.filter(item => this.moreArr.indexOf(item) == -1);
        for (let i = 0; i < item.metas.length; i++) {
          for (let j = 0; j < arr2.length; j++) {
            if (item.metas[i].key == arr2[j]) {
              // console.log(6966666);
              this.changeArrValue(
                this.answer_state_list,
                this.current_index,
                i,
                "answer-none"
              );
            }
          }
        }
        // console.log(this.answer_state_list);
        // 显示解析
        this.$set(
          this.error_list,
          this.current_index,
          !this.error_list[this.current_index]
        );
        this.answer_state_lock[this.current_index] = true;
        this.moreArr = [];
        this.$set(this.more_list, this.current_index, false);
        this.$set(this.err_or_true_list, this.current_index, false);
      }
      // 插入用户答案v3
      item.userAnswer = showUserAnswer
      // 显示解析
      this.$set(
        this.error_list,
        this.current_index,
        true
      );

      // // 查看报告
      // if(this.current_index==this.wrong_list.length-1){
      //   this.$nextTick(()=>{
      //     this.goReport()
      //   })
      // }



    },
    goReport(){
      sessionStorage.setItem('currQuestionIndex',this.current_index)
      sessionStorage.setItem('answer_state_lock',JSON.stringify(this.answer_state_lock))
      sessionStorage.setItem('wrong_list',JSON.stringify(this.wrong_list))
      sessionStorage.setItem('answer_state_list',JSON.stringify(this.answer_state_list))
      sessionStorage.setItem('active_list',JSON.stringify(this.active_list))


      return this.$router.push({
        path:'KnowledgeStudyEnd',
        query:{
          course_id:this.$route.query.course_id,
          chapter_id:this.$route.query.chapter_id,
          k_id:this.$route.query.k_id,
          rule_tag:this.$route.query.rule_tag,
          course_chapter_id:this.$route.query.course_chapter_id,
          knowledge_id:this.$route.query.knowledge_id,
        }
      })
    },
    onChange(index) {
      this.current_index = index;
      for (let i = 0; i < this.active_list.length; i++) {
        this.active_list[i] = [];
      }
      let arr = [];
      for (let i = 0; i < this.moreArr.length; i++) {
        this.moreArr[i] = "";
      }
      this.sum = 0;
      if (this.sum >= 2) {
        this.$set(this.more_list, this.current_index, true);
      } else {
        this.$set(this.more_list, this.current_index, false);
      }
      // console.log(index);
    },
    up_click() {
      this.value1 = "";
      this.moreArr=[]
      if (this.current_index == 0) {
        this.$message({
          showClose: true,
          message: "已经是第一题了哦",
          type: "warning"
        });
      } else {
        this.current_index -= 1;
        for (let i = 0; i < this.active_list.length; i++) {
          this.active_list[i] = [];
        }
        let arr = [];
        for (let i = 0; i < this.moreArr.length; i++) {
          this.moreArr[i] = "";
        }
        this.sum = 0;
        if (this.sum >= 2) {
          this.$set(this.more_list, this.current_index, true);
        } else {
          this.$set(this.more_list, this.current_index, false);
        }
      }
      this.value = "";
    },
    next_click() {
      this.value1 = "";
      this.moreArr=[]
      if (this.current_index == this.answer_state_list.length - 1) {
        this.$message({
          showClose: true,
          message: "最后一题了",
          type: "warning"
        });
      } else {
        this.current_index = Number(this.current_index) + 1;
        for (let i = 0; i < this.active_list.length; i++) {
          this.active_list[i] = [];
        }
        let arr = [];
        for (let i = 0; i < this.moreArr.length; i++) {
          this.moreArr[i] = "";
        }
        this.sum = 0;
        if (this.sum >= 2) {
          this.$set(this.more_list, this.current_index, true);
        } else {
          this.$set(this.more_list, this.current_index, false);
        }
      }
      this.value = "";
    },
    input_c(value) {
      if (value) {
        this.btn_show = false;
      } else {
        this.btn_show = true;
      }
    },
    btn_click() {
      window.open(`${appConfig.ShoppUrl}ask/related${this.wrong_list[this.current_index].question_id}`);
    },
    btn_click_kjc() {
      console.log(this.value);
      let commObj = {};
      commObj.source_id = this.wrong_list[this.current_index].id;
      commObj.source_type = "question";
      commObj.content = this.value;
      this.saveComment(commObj);
      console.log(this.wrong_list[this.current_index])
    },

    // 点击解析显示隐藏
    analysis_click() {
      this.$set(
        this.error_list,
        this.current_index,
        !this.error_list[this.current_index]
      ); // 改变数组 直接改变数组视图无法更新
    },
    // 计算器显示
    calc_click(){
      this.$layer.closeAll('iframe');
        //显示主观弹窗
        let layerId = this.$layer.iframe({
          id: 1,
          type: 2,
          title: '蜜蜂岛计算器',
          // area:['260px','380px'],
          area:['250px','328px'],
          shade:0,
          zIndex :525,
          shade: false,
          shadeClose: false,
          content: {
            content: calc, //传递的组件对象
            parent: this,//当前的vue对象
            data:{}
          },
          cancel:()=>{
            this.$layer.closeAll('iframe');
          }
        });
    },
    // 点击收藏
    collection_click() {
      if (this.wrong_list[this.current_index].is_favorite == 1) {
        this.wrong_list[this.current_index].is_favorite = 0;
      } else {
        this.wrong_list[this.current_index].is_favorite = 1;
      }
      this.saveFavorite(this.wrong_list[this.current_index].id);
    },
    car_click() {
      this.show = true;
      for (let i = 0; i < this.err_or_true_list.length; i++) {
        if (this.err_or_true_list[i] != "h") {
          this.Again_show = true;
        }
      }
    },
    again_click() {
      let obj = {};
      obj.chapter_id = this.$route.query.chapter_id;
      obj.course_id = this.$route.query.course_id;
      obj.rule_tag = this.$route.query.rule_tag||'ai_chapter';
      obj.course_chapter_id = this.$route.query.course_chapter_id;
      obj.redo = 1;
      this.request(obj);
      // this.current_index += 1;
      // for (let i = 0; i < this.err_or_true_list.length; i++) {
      //   this.err_or_true_list[i] = "h";
      // }

      // for (let i = 0; i < this.answer_state_list.length; i++) {
      //   this.answer_state_list[i] = [];
      // }
      // for (let i = 0; i < this.answer_state_lock.length; i++) {
      //   this.answer_state_lock[i] = false;
      // }
      // for (let i = 0; i < this.error_list.length; i++) {
      //   this.error_list[i] = false;
      // }
      // for (let i = 0; i < this.more_list.length; i++) {
      //   this.more_list[i] = false;
      // }
      // for (let i = 0; i < this.active_list.length; i++) {
      //   this.active_list[i] = [];
      // }
      // this.moreArr = [];
      // this.sum = 0;
      // // this.Jump_index = 0;
      // this.current_index = 0;
      // this.Again_show = false;
      // console.log(this.Again_show);
    },
    // 点击答题卡序号
    card_cl(i) {
      // console.log('当前号码:',i,'上一题号码',this.current_index+1)
      if(i==this.current_index+1) return
      this.moreArr = []

      this.Jump_index = i - 1;
      this.current_index = i - 1;
      this.show = false;
      this.sum = 0;
      if (this.sum >= 2) {
        this.$set(this.more_list, this.current_index, true);
      } else {
        this.$set(this.more_list, this.current_index, false);
      }
    },
    // 简答题
    input_blur(index, item) {
      console.log(this.answer_state_list);
      this.changeArrValue(
        this.answer_state_list,
        this.current_index,
        0,
        this.value1
      );
      this.$set(this.more_list, this.current_index, false);
      this.$set(this.err_or_true_list, this.current_index, true);
      this.changeArrValue(this.answer_state_list, this.current_index, 1, true);
      this.answer_state_lock[this.current_index] = true;
      let Mobj = {};
      Mobj.rule_tag = this.rule_tag;
      Mobj.chapter_id = this.chapter_id;
      Mobj.question_id = item.question_id;
      Mobj.userAnswer = this.value1;
      Mobj.trueAnswer = item.trueAnswer;
      this.saveResult(Mobj);
      this.value1 = "";
    },
    input_value(value) {
      // console.log(value);
      if (value != "") {
        this.$set(this.more_list, this.current_index, true);
      }
      this.value1 = value;
    },
    async reload(){
      console.log('进入reload')
        this.current_index=0
        this.chapter_id = this.$route.query.chapter_id;
        // console.log(this.$route.query.subject_id);\
        this.rule_tag = this.$route.query.rule_tag||'ai_chapter';
        if (this.$route.query.cid) {
          let obj1 = {};
          obj1.chapter_id = this.$route.query.chapter_id;
          obj1.course_id = this.$route.query.course_id;
          obj1.rule_tag = this.$route.query.rule_tag||'ai_chapter';
          obj1.course_chapter_id = this.$route.query.course_chapter_id;
          // obj1.cid = this.$route.query.cid;
          await this.request1(obj1);
        } else {
          let obj = {};
          obj.chapter_id = this.$route.query.chapter_id;
          obj.course_id = this.$route.query.course_id;
          obj.rule_tag = this.$route.query.rule_tag||'ai_chapter';
          obj.course_chapter_id = this.$route.query.course_chapter_id;
          await this.request(obj);
        }

        console.log(this.answer_state_list);


        if(this.$route.query.isBr==1){
          await this.videoDtailM(this.$route.query.chapter_id);
        }

        
    },




  }
};
</script>
<style lang="scss" scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .report{
      float: right;
      border: 0;
      background-color: #fadc1e;
      border-radius: 4px;
      height:50px;
      padding:0 20px;
    }
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 422px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .topic_card {
        padding: 0 42px;
        .card_alt {
          padding-bottom: 21px;
          border-bottom: 1px solid #eee;
          margin-bottom: 34px;
          .card_alt_item {
            float: left;
            font-size: 14px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            line-height: 12px;
            margin-right: 18px;
            span {
              float: left;
              display: block;
              width: 12px;
              height: 12px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(204, 204, 204, 1);
              border-radius: 50%;
              margin-right: 5px;
            }
            .red {
              background: rgba(232, 66, 51, 0.2);
              border: 1px solid rgba(232, 66, 51, 1);
            }
            .lv {
              background: rgba(12, 213, 109, 0.2);
              border: 1px solid rgba(12, 213, 109, 1);
            }
          }
        }
        .topic_card_box {
          height: 500px;
          overflow-y: scroll;
          margin-bottom: 30px;
          .topic_card_item {
            margin-bottom: 34px;
            .card_item_title {
              font-size: 16px;
              font-weight: 500;
              color: rgba(43, 43, 43, 1);
              margin-bottom: 21px;
            }
            .card_box {
              border-bottom: 1px solid #eee;
              .number_list {
                cursor: pointer;
                float: left;
                width: 34px;
                height: 34px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(204, 204, 204, 1);
                font-size: 14px;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                text-align: center;
                line-height: 34px;
                border-radius: 50%;
                margin-right: 35px;
                margin-bottom: 20px;
                &:nth-of-type(5n) {
                  margin-right: 0;
                }
              }
              .lv {
                background: rgba(12, 213, 109, 0.2);
                border: 1px solid rgba(12, 213, 109, 1);
                color: rgba(12, 213, 109, 1);
              }
              .red {
                background: rgba(232, 66, 51, 0.2);
                border: 1px solid rgba(232, 66, 51, 1);
                color: rgba(232, 66, 51, 1);
              }
            }
          }
        }
        /*修改滚动条样式*/
        .topic_card_box::-webkit-scrollbar {
          width: 10px;
          height: 10px;
          /**/
        }
        .topic_card_box::-webkit-scrollbar-track {
          background: rgb(239, 239, 239);
          border-radius: 2px;
        }
        .topic_card_box::-webkit-scrollbar-thumb {
          background: #fadc1e;
          border-radius: 10px;
        }
        .topic_card_box::-webkit-scrollbar-thumb:hover {
          background: #333;
        }
        .topic_card_box::-webkit-scrollbar-corner {
          background: #179a16;
        }
        .new_make {
          cursor: pointer;
          width: 258px;
          height: 37px;
          background: rgba(238, 238, 238, 0.6);
          border-radius: 4px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          text-align: center;
          line-height: 37px;
          margin: 0 auto 50px auto;
        }
        .huang {
          background-color: #fadc1e;
        }
      }
    }
    .content_box_r {
      float: right;
      width: 913px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_r_title {
        padding: 20px 0 24px 51px;
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        border-bottom: 1px solid #eee;
        img {
          float: left;
          width: 31px;
          height: 32px;
          margin-right: 16px;
        }
      }
      .work_box {
        padding: 0 50px 80px 50px;

        .work_box_title {
          padding: 21px 0;
          border-bottom: 1px solid #eee;
          .name {
            cursor: pointer;
            float: left;
            position: relative;
            margin-right: 32px;
            .name_c {
              border-bottom: 1px solid #eee;
              font-size: 18px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              z-index: 999;
            }
            span {
              position: absolute;
              bottom: -10px;
              left: 0;
              width: 100%;
              display: block;
              height: 12px;
              background: rgba(250, 220, 30, 1);
            }
          }
        }
        .work_box_content {
          padding: 24px 30px 0 30px;

          .topic_top {
            font-size: 20px;
            font-weight: 500;
            color: rgba(43, 43, 43, 1);
            margin-bottom: 32px;
            .number {
              float: left;
              span {
                font-size: 25px;
                color: rgba(255, 0, 54, 1);
              }
            }
            .type {
              float: left;
              margin-left: 19px;
              line-height: 36px;
            }
          }
          .topic_bottom {
            border-bottom: 1px solid #eee;
            margin-bottom: 32px;
            .work_name {
              // width: 587px;
              font-size: 18px;
              font-weight: 500;
              color: rgba(43, 43, 43, 1);
              margin-bottom: 40px;
            }
            .answer {
              .answer_list {
                line-height: 32px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(43, 43, 43, 1);
                margin-bottom: 42px;
                span {
                  cursor: pointer;
                  float: left;
                  width: 34px;
                  height: 34px;
                  background: rgba(255, 255, 255, 1);
                  border: 1px solid rgba(204, 204, 204, 1);
                  font-size: 16px;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                  text-align: center;
                  line-height: 34px;
                  border-radius: 50%;
                  margin-right: 24px;
                }
                .more {
                  border-radius: 4px;
                }
                .work_key {
                  white-space: pre-wrap !important;
                }
                .answer-right {
                  background: rgba(12, 213, 109, 0.2) !important;
                  border: 2px solid rgba(12, 213, 109, 1) !important;
                  color: #0cd56d !important;
                }
                .answer-error {
                  background: rgba(232, 66, 51, 0.2) !important;
                  border: 2px solid rgba(232, 66, 51, 1) !important ;
                  color: rgba(232, 66, 51, 1) !important;
                }
                .answer-none {
                  background: rgba(12, 213, 109, 0.2) !important;
                  border: 2px solid rgba(12, 213, 109, 1) !important;
                  color: #0cd56d;
                }
                .huang {
                  background: rgba(250, 220, 30, 0.2);
                  border: 2px solid rgba(250, 220, 30, 1);
                }
              }
              .el-textarea {
                width: 587px;
                margin-bottom: 50px;
              }
            }
          }
          .yida{
              display: flex;
              padding-bottom: 52px;
              padding-top: 20px;
              >div{
                margin-left: 30px;
                border-radius: 23px;
                font-size: 12px;
                font-weight: 500;
                color: #333333;
                padding: 8px 15px;
                display: flex;
                justify-content: center;
                align-items: center;
                &:first-of-type{
                  margin-left: 0;
                }
                span{
                  margin-left: 16px;
                  font-size: 16px;
                  font-weight: 600;
                  color: #1FD6A8;
                }
              }
            }
          .certain {
            .certain_btn {
              cursor: pointer;
              margin: auto;
              width: 258px;
              height: 37px;
              background: rgba(238, 238, 238, 0.6);
              border-radius: 4px;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
              text-align: center;
              line-height: 37px;
            }
            .huang {
              background-color: #fadc1e;
              color: #333;
            }
          }
          // 解析
          .min_title {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            margin-bottom: 33px;
            span {
              display: block;
              float: left;
              width: 6px;
              height: 30px;
              background: rgba(250, 220, 30, 1);
              border-radius: 3px;
              margin-right: 16px;
            }
          }
          .resolve {
            .trueanswer {
              font-size: 16px;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              margin-bottom: 26px;
              span {
                font-size: 18px;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
              }
            }
          }
          .alt {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 24px;
          }
          .textarea_box {
            .btn {
              cursor: pointer;
              float: right;
              width: 85px;
              height: 33px;
              background: rgba(250, 220, 30, 1);
              border-radius: 4px;
              margin-top: 16px;
              font-size: 16px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              line-height: 22px;
              text-align: center;
              line-height: 33px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .operate_box {
            margin-top: 80px;
            .operate_box_l {
              float: left;
              .up,
              .next {
                cursor: pointer;
                float: left;
                width: 73px;
                height: 31px;
                background: rgba(0, 69, 96, 0.04);
                border: 1px solid rgba(238, 238, 238, 1);
                font-size: 16px;
                font-weight: 500;
                color: rgba(102, 102, 102, 1);
                text-align: center;
                line-height: 31px;
              }
              .next {
                margin-left: 42px;
              }
              .hui {
                border: 1px solid rgba(238, 238, 238, 1);
                background: rgba(238, 238, 238, 1);
                color: rgba(153, 153, 153, 1);
              }
            }
            .operate_box_r {
              float: right;
              .faver,
              .show_resolve {
                cursor: pointer;
                float: left;
                background: rgba(0, 69, 96, 0.04);
                border-radius: 4px;
                border: 1px solid rgba(238, 238, 238, 1);
                padding: 7px 12px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                img {
                  float: left;
                  width: 18px;
                  height: 18px;
                  margin-right: 8px;
                }
              }
              .show_resolve {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
}

.videoBox{
  // border-top: 16px solid #F9F9F9;
  // border-bottom: 16px solid #F9F9F9;
  overflow: hidden;
  
  .vBox{
    width: 200px;
    position: relative;
    padding: 36px 0 0 0;
    font-size: 0;
    float: left;
    box-sizing: border-box;
    margin-right: 64px;
    margin-bottom:10px;
    &:first-of-type{
      padding-right: 10px;
    }
    &:last-of-type{
      padding-left: 10px;
    }
    .vTitle{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      color: #333333;
      position: relative;
      padding-left: 20px;
      &::before{
        position: absolute;
        left: 0;
        top: -4px;
        content: '';
        background: #FADA1E;
        width: 6px;
        height: 30px;
      }
    }
    img{
      margin-top: 20px;
      height: 120px;
      object-fit: cover;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
      border-radius: 16px;
      width: 100%;
    }
    .zhezhao{
      width: calc(100% - 20px);
      height: 120px;
      background: rgba(0,0,0,.6);
      position: absolute;
      bottom: 0;
      top: initial !important;
      left: initial !important;
      z-index: 2;
      border-radius: 16px;
      cursor: pointer;
    }
    span{
      position: absolute;
      z-index: 3;
      bottom: 8px;
      right:16px;
      color: white;
      font-size: 14px;
    }
  }
}
</style>
<style lang="scss">
.el-breadcrumb__inner.is-link {
  font-weight: 500;
}
.el-breadcrumb__inner.is-link:hover {
  color: #333;
}
.el-textarea__inner {
  background-color: #eeeeee;
  border: 1px solid #eee;
}
.ggVideoBox{
  .el-dialog__body{
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }
}
</style>